import { FCC } from "@/types/common";
import { TGetCompanyDto } from "@/api/services/main/company/dtos/get-company.dto";
import { Avatar, Box, Grid, Stack, Tooltip } from "@mui/material";
import { deepOrange, deepPurple, blue, green, pink, amber } from "@mui/material/colors";
import { useEffect, useState } from "react";
import { useCopyToClipboard } from "@/features/company/hooks/useCopyToClipboard";
import { InnerBox } from "@/components/elements/InnerBox";
import { CompanyFormTitle } from "@/features/company/components/company-info/CompanyFormTitle";
import { ItemInfo } from "@/components/commons/ItemInfo";
import { secondary } from "@/theme/colors";
import { useParams } from "react-router-dom";
import { formatPhone } from "@/utils/string";
import { IconCopyEmail } from "@/assets/icons/IconCopyEmail";

type TCompanyContactInfoProps = {
  defaultValues: Partial<TGetCompanyDto>;
};

const colors = [deepOrange[500], deepPurple[500], blue[500], green[500], pink[500], amber[500]];
const getRandomColor = () => {
  const index = Math.floor(Math.random() * colors.length);
  return colors[index];
};
export const CompanyContactInfo: FCC<TCompanyContactInfoProps> = ({ defaultValues }) => {
  const { companyId } = useParams();
  const [bgColor] = useState<string>(() => {
    const savedColor = localStorage.getItem(`companyBgColor_${companyId}`);
    if (savedColor) return savedColor;
    const newColor = getRandomColor();
    localStorage.setItem(`companyBgColor_${companyId}`, newColor);
    return newColor;
  });
  const [firstChar, setFirstChar] = useState<string>();
  const isShowIconCopy = !!defaultValues.contactPersonEmail;
  const {
    message: messageTooltip,
    copy: handleCopy
  } = useCopyToClipboard({
    value: defaultValues.contactPersonEmail ?? undefined,
    hoverMessage: "メールアドレスをコピー",
    copiedMessage: "メールアドレスをコピーしました。",
    fallbackMessage: "メールアドレスのコピーに失敗しました。",
    resetDelay: 2000,
  });

  useEffect(() => {
    if (defaultValues.contactPersonName) {
      const char = defaultValues.contactPersonName.charAt(0).toUpperCase();
      setFirstChar(char);
    }
  }, [defaultValues.contactPersonName]);
  return (
    <InnerBox title={<CompanyFormTitle text="担当者情報" />} showDivider={false}>
      <Grid
        container
        spacing={3}
        sx={{
          marginBottom: "16px",
        }}
      >
        <Grid item xs={6}>
          <Stack direction="row" gap={2}>
            <Stack direction="column" alignContent="center" flexWrap="nowrap" justifyContent="center">
              <Avatar sx={{ width: 32, height: 32, bgcolor: bgColor, marginBottom: "20px" }}>{firstChar}</Avatar>
            </Stack>
            <Stack width="100%">
              <ItemInfo label="名前" value={defaultValues?.contactPersonName} />
            </Stack>
          </Stack>
        </Grid>
        <Grid item xs={6}>
          <ItemInfo label="役職" value={defaultValues?.contactPersonJobTitle} />
        </Grid>
        <Grid item xs={6}>
          <ItemInfo label="電話番号" value={defaultValues?.contactPersonPhone ? formatPhone(defaultValues.contactPersonPhone) : undefined} isShowDivider={false} />
        </Grid>
        <Grid item xs={6}>
            <Box display="flex" alignItems="center">
              <ItemInfo
                color={defaultValues?.contactPersonEmail ? secondary[80] : ""}
                label="メールアドレス"
                value={defaultValues?.contactPersonEmail}
                isShowDivider={false}
                endIcon={isShowIconCopy ?
                  <Tooltip title={messageTooltip}>
                    <Box flexGrow={1}>
                        <IconCopyEmail onClick={handleCopy} cursor="pointer" />
                    </Box>
                  </Tooltip>
                : null}
              />
            </Box>
        </Grid>
      </Grid>
    </InnerBox>
  );
};
